export default "__VITE_PUBLIC_ASSET__4c500e6e__"